import React, { useState } from 'react';
import { GlassMagnifier } from 'react-image-magnifiers';
import styles from './BeforeAfterMobile.module.sass';
import BeforeAfterImage1 from '../../../../images/pages/balancing_clearing_serum/before_after_mobile/img1.png';
import BeforeAfterImage2 from '../../../../images/pages/balancing_clearing_serum/before_after_mobile/img2.png';
import BeforeAfterImage3 from '../../../../images/pages/balancing_clearing_serum/before_after_mobile/img3.png';
import BeforeAfterImage4 from '../../../../images/pages/balancing_clearing_serum/before_after_mobile/img4.png';
import BeforeAfterImage5 from '../../../../images/pages/balancing_clearing_serum/before_after_mobile/img5.png';
import Button from '../../../ui_kit/button/Button';

function BeforeAfterMobile() {
  const [showMore, setShowMore] = useState(false);

  const onButtonClick = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  return (
    <div className={styles['mobile-images']}>
      <GlassMagnifier
        imageSrc={BeforeAfterImage1.src}
        imageAlt="Before and after result 1"
        square
        magnifierSize="50%"
        largeImageSrc={BeforeAfterImage1.src}
      />
      <GlassMagnifier
        imageSrc={BeforeAfterImage2.src}
        imageAlt="Before and after result 2"
        square
        magnifierSize="50%"
        largeImageSrc={BeforeAfterImage2.src}
      />
      {showMore && (
        <>
          <GlassMagnifier
            imageSrc={BeforeAfterImage3.src}
            imageAlt="Before and after result 3"
            square
            magnifierSize="50%"
            largeImageSrc={BeforeAfterImage3.src}
          />
          <GlassMagnifier
            imageSrc={BeforeAfterImage4.src}
            imageAlt="Before and after result 4"
            square
            magnifierSize="50%"
            largeImageSrc={BeforeAfterImage4.src}
          />
          <GlassMagnifier
            imageSrc={BeforeAfterImage5.src}
            imageAlt="Before and after result 5"
            square
            magnifierSize="50%"
            largeImageSrc={BeforeAfterImage5.src}
          />
        </>
      )}
      <Button
        text={showMore ? 'CLICK TO CLOSE' : 'CLICK TO VIEW MORE'}
        size="small"
        color="blue"
        className={`button ${styles['view-more-button']}`}
        onClickHandler={onButtonClick}
      />
    </div>
  );
}

export default BeforeAfterMobile;
